// extracted by css-extract-rspack-plugin
export default {"link":"FeedbackLink-module__link__KL3Zz8A"};